'use client';

import { useEffect } from 'react';
import { useGlobalContext } from '@/store/contexts/global-context';
import { useStore } from '@/store/store';
import { AMPLITUDE_EXPERIMENTS, isExperimentEnabled } from '@/utils/experiments';
import { getCookieValue, setCookie, removeCookie } from '@/utils/cookies/client';
import { COOKIES } from '@/utils/cookies/constants';
import { getConfig } from '@/utils/config/config';
import { sendExposureEvent } from '@/tracking/amplitude/events/general/experiment-exposure';

export const GameWindowExperimentEffects = () => {
    const { experiments } = useGlobalContext();
    const { rootDomain } = getConfig();
    const { sendEvent } = useStore((state) => state.tracking);

    useEffect(() => {
        const hasExperimentAssignment = !!experiments[AMPLITUDE_EXPERIMENTS.GAME_WINDOW_V3];
        const isInGameWindowV3Experiment = isExperimentEnabled(experiments, AMPLITUDE_EXPERIMENTS.GAME_WINDOW_V3);
        const hasGameWindowCookie = getCookieValue(COOKIES.USE_GAME_WINDOW) === 'true';

        // Send exposure for any assignment (on or off/control)
        if (hasExperimentAssignment) {
            sendExposureEvent(experiments, AMPLITUDE_EXPERIMENTS.GAME_WINDOW_V3, sendEvent);
        }

        // Manage cookie based on variant
        if (isInGameWindowV3Experiment && !hasGameWindowCookie) {
            setCookie(COOKIES.USE_GAME_WINDOW, 'true', undefined, '/', rootDomain);
        } else if (!isInGameWindowV3Experiment && hasGameWindowCookie) {
            removeCookie(COOKIES.USE_GAME_WINDOW, '/', rootDomain);
        }
    }, [experiments, rootDomain, sendEvent]);

    return <div data-testid="game-window-experiment-effects" hidden />;
};
